function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

// https://govuk-elements.herokuapp.com/data/
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
import { GREY_2 } from 'govuk-colours';
var CellInner = styled('td')(function (_ref) {
  var _ref2;

  var alignRight = _ref.alignRight;
  return _ref2 = {
    border: 0,
    borderBottom: "1px solid " + GREY_2,
    fontFamily: NTA_LIGHT,
    fontWeight: 400,
    fontSize: FONT_SIZE.SIZE_16,
    lineHeight: LINE_HEIGHT.SIZE_16,
    padding: '0.63158em 1.05263em 0.47368em 0',
    textAlign: alignRight ? 'right' : 'left',
    textTransform: 'none',
    wordBreak: 'break-word',
    ':last-child': {
      paddingRight: 0
    }
  }, _ref2[MEDIA_QUERIES.LARGESCREEN] = {
    fontSize: FONT_SIZE.SIZE_19,
    lineHeight: LINE_HEIGHT.SIZE_19
  }, _ref2;
});

var Cell = function Cell(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return React.createElement(CellInner, props, children);
};

export default Cell;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/table/es/atoms/Cell/index.js
// module id = 311
// module chunks = 0